/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Shashank's Portfolio",
  description:
    "A driven and passionate individual dedicated to creating impactful, sustainable, and scalable solutions. With a focus on end-to-end product development, I aim to build social and technical systems that make a lasting difference. Whether working on innovative technologies or meaningful projects, I am committed to delivering results that benefit both society and industry.",
  og: {
    title: "Shashank Portfolio",
    type: "website",
    url: "http://shashankyama.com/",
  },
};

//Home Page
const greeting = {
  title: "Shashank Yama",
  logo_name: "ShashankYama",
  subTitle:
    "A driven and passionate individual dedicated to creating impactful, sustainable, and scalable solutions. With a focus on end-to-end product development, I aim to build social and technical systems that make a lasting difference.",
  resumeLink:
    "https://drive.google.com/file/d/1-22i-P2GFH_AymJsT87_OclgoBkTrUaq/view?usp=drivesdk",
  // portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/yshashankdev",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/yshashankdev",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/shashank-yama/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "Leetcode",
  //   link: "https://leetcode.com/u/DinoToothbrushWithNinjaSause/",
  //   iconifyClassname: "simple-icons:leetcode",
  //   backgroundColor: "#111", // Reference https://simpleicons.org/?q=leetcode
  // },
  {
    name: "Gmail",
    link: "mailto:shashankyamaft@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14835", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Application Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready applications",
        "⚡ Excellent Problem-Solving skills and very good understanding of Data Structures and Algorithms",
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Creating application backend in Node, Express & Flask",
        "⚡ Experience in working with various tech stacks and technologies",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: "Cloud and Databases",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on different cloud platforms",
        "⚡ Experience in working with both SQL and NoSQL databases like MySQl, PostgreSQL and MongoDB",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/DinoToothbrushWithNinjaSause/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University at Buffalo, SUNY",
      subtitle: "Master's in Computer Science and Engineering",
      logo_path: "ub2.png",
      alt_name: "SUNYBUFFALO",
      duration: "2022 - 2023",
      descriptions: [
        "⚡ I have got advanced understanding in courses like DS, Algorithms, DBMS, OS, CA, ML etc.",
        "⚡ Apart from this, I have done courses on Blockchain Application Development, Predictive Analytics and Full Stack Development.",
        "⚡ Worked on real time project developing a website for local barber.",
      ],
      website_link: "https://www.buffalo.edu/",
    },
    {
      title: "VNR VJIET",
      subtitle: "Bachelor's in Information Technology",
      logo_path: "vnr1.png",
      alt_name: "VNR Vignana Jyothi",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses which include Algorithms, Data Structures, Data Mining, Operating Systems, Math, Compiler Design etc.",
        "⚡ Apart from this, I have also worked on different projects starting from calculator to automated attendance using face recognition.",
        "⚡ During my time at university, I worked as an intern at Thomson Reuters.",
      ],
      website_link: "https://vnrvjiet.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    //
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I have worked with various organizations, where I have honed a diverse set of skills in web development. From front-end design to back-end and database management, I have gained comprehensive expertise in building robust, scalable web applications. Additionally, I have experience in testing, ensuring that the applications I develop are reliable, secure, and meet industry standards.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software Developer",
          company: "Dataverse Consulting Inc",
          company_url: "https://www.dataverseconsulting.net/",
          logo_path: "dataverse.jpeg",
          duration: "Sep 2023 - Present",
          location: "Bloomington, IL, USA",
          description:
            "Developing web applications using Java and React, focusing on designing and building dynamic, responsive single-page applications (SPAs). Leveraging React for a seamless user experience on the front end while utilizing Java on the back end for robust, scalable server-side logic. This includes implementing RESTful APIs, ensuring efficient data handling, and creating reusable components to streamline the development process.",
          color: "#000000",
        },
        {
          title: "Application Developer",
          company: "Technosoft Solutions",
          company_url: "https://www.technosoftsolutions.in/",
          logo_path: "ts.png",
          duration: "July 2021 - Dec 2021",
          location: "Hyderabad, Telangana",
          description:
            "Worked on developing a web application for a business, enabling them to manage their operations more efficiently. This involved creating a comprehensive solution that streamlined workflows, improved data management, and provided insightful analytics. By integrating user-friendly interfaces and robust back-end functionality, I helped the business enhance its productivity and decision-making capabilities.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Technology Intern",
          company: "Thomson Reuters.",
          company_url: "https://www.thomsonreuters.com/en.html",
          logo_path: "tr.png",
          duration: "Dec 2020 - May 2021",
          location: "Hyderabad, India",
          description:
            "Worked on testing a web application using selenium with C# and NUnit. Performed API testing using postman. Scheduled daily jobs on jenkins and documented product defects.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a wide range of cutting-edge technology tools, with my core expertise lying in the creation and deployment of web applications.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "avatar.png",
    description: "Please feel free to reach out to me from the email below.",
  },
  blogSection: {
    title: "Blogs",
    subtitle: "sharing.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Dallas, TX, USA 75067",
    locality: "Dalla",
    country: "USA",
    region: "Texas",
    postalCode: "75067",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/733cX7gxXKwTCaa47",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
